import apiClient from 'apiClient';
import withCaseErrorMiddleware from '../caseError/withCaseErrorMiddleware';
import { PatchExpenditureResponseData } from '../types';

import { PostResponse, DeleteResponse, PatchResponse } from './types';

const PREFIX = '/api/v1/cases';

export const postLiability = (caseId: string, applicantId: number): PostResponse => {
  return apiClient.post(`${PREFIX}/${caseId}/applicant/${applicantId}/expenditures`);
};

export const deleteLiability = (caseId: string, applicantId: number, liabilityId: number): DeleteResponse => {
  return apiClient.delete(`${PREFIX}/${caseId}/applicant/${applicantId}/expenditures/${liabilityId}`);
};

export const patchLiability = (
  caseId: string,
  applicantId: number,
  liabilityId: number,
  field: string,
  value: any,
): PatchResponse => {
  return apiClient
    .patch<PatchExpenditureResponseData>(`${PREFIX}/${caseId}/applicant/${applicantId}/expenditures/${liabilityId}`, {
      [field]: value,
    })
    .then(withCaseErrorMiddleware);
};
